const DEFAULT_API_URL = 'http://localhost:5000';

export const getApiBaseUrl = () => {
    const configuredUrl = process.env.REACT_APP_API_URL || DEFAULT_API_URL;
    return configuredUrl.replace(/\/$/, '');
};

export const apiUrl = (path) => {
    const normalizedPath = path.startsWith('/') ? path : `/${path}`;
    return `${getApiBaseUrl()}${normalizedPath}`;
};

export const getCsrfToken = async () => {
    const response = await fetch(apiUrl('/api/csrf-token'), {
        credentials: 'include'
    });
    let data;
    try {
        data = await response.json();
    } catch (error) {
        throw new Error('Unable to prepare a secure request.');
    }
    if (!response.ok || data.success !== true || !data.csrf_token) {
        throw new Error(data.error || 'Unable to prepare a secure request.');
    }
    return data.csrf_token;
};
